import { useAuth0 } from "@auth0/auth0-react";
// import { AnimatePresence } from "framer-motion";
// import { cloneElement } from "react";
import {
  Navigate,
  Outlet,
  // useLocation,
  useRoutes,
} from "react-router-dom";
import PermissionProtectedRoute from "./PermissionProtectedRoute";
import PermissionsProvider from "./utils/auth/PermissionsContext";
// import AreaOAD from "./routes/area-aggregate/AreaOAD";
// import AreaWeather from "./routes/area-aggregate/AreaWeather";
// import AreaWeenat from "./routes/area-aggregate/AreaWeenat";
import { ErrorComponent } from "./routes/error/ErrorPage";
import { FourOhFour } from "./routes/error/FourOhFour";
import { FullPageLoadingScreen } from "./routes/FullPageLoadingScreen";
import Layout from "./routes/layout/Layout";
import { SignIn } from "./routes/Signin";
import { HasChildren } from "./types/shared";
import { Suspense } from "react";
import { LoadingSpinner } from "./components/LoadingIndicator";
import ClientAreasComponent from "./routes/client-areas/client-areas.component";
import ClientAreasDataLoader from "./routes/client-areas/client-areas.data-loader";
import ClientAreasValidator from "./routes/client-areas/client-areas.validator";
import { ErrorBoundary } from "react-error-boundary";
import Oops from "./routes/error/oops";
import { PageContainer } from "./components/page";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-ignore
import tw from "twin.macro";
import { useTranslation } from "react-i18next";
import BottomNavigation from "./components/BottomNavigation";

const AuthenticationGuard = ({ children }: HasChildren) => {
  const { isLoading, isAuthenticated, error } = useAuth0();

  if (error) {
    return <ErrorComponent subtitle={error.message} />;
  }

  if (!isLoading && !isAuthenticated) {
    return <Navigate to={"signin"} />;
  }

  if (isAuthenticated) {
    return (
      <PermissionsProvider>
        {children || <Outlet />}
        <BottomNavigation />
      </PermissionsProvider>
    );
  }

  return <FullPageLoadingScreen show />;
};

type AnimatedRoutesProps = {
  isAppInitialized: boolean;
};

export const AnimatedRoutes = ({ isAppInitialized }: AnimatedRoutesProps) => {
  const { t: translator } = useTranslation();
  // Hook equivalent to <Routes />
  const Element = useRoutes([
    {
      path: "/",
      children: [
        {
          element: <AuthenticationGuard />,
          children: [
            {
              element: <PermissionProtectedRoute permission="client" />,
              children: [
                {
                  children: [
                    {
                      index: true,
                      element: (
                        <ErrorBoundary fallback={<Oops />}>
                          <Suspense
                            fallback={
                              <PageContainer>
                                <div tw="flex justify-center items-center min-h-[60vh] py-16">
                                  <LoadingSpinner tw="text-primary-800 size-20" />
                                  <p tw="p-2 text-primary-800/50 text-sm">
                                    {translator("loadingClientData")}
                                  </p>
                                </div>
                              </PageContainer>
                            }
                          >
                            <ClientAreasDataLoader>
                              <ClientAreasValidator>
                                <ClientAreasComponent />
                              </ClientAreasValidator>
                            </ClientAreasDataLoader>
                          </Suspense>
                        </ErrorBoundary>
                      ),
                    },
                    {
                      path: "*",
                      element: <FourOhFour />,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: "signin",
          element: <SignIn />,
        },
      ],
    },
  ]);

  // const location = useLocation();

  if (!isAppInitialized) return null; // Loading screen

  if (!Element) return <div>An error occured</div>; // Error page (404)

  return (
    <Layout>
      {/* <AnimatePresence mode="wait">
        {cloneElement(Element, { key: location.pathname })}
      </AnimatePresence> */}
      {Element}
    </Layout>
  );
};
